import { render } from "./BtnRightIcon.vue?vue&type=template&id=57daf72b"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/BtnRightIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57daf72b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57daf72b', __exports__)) {
    api.reload('57daf72b', __exports__)
  }
  
  module.hot.accept("./BtnRightIcon.vue?vue&type=template&id=57daf72b", () => {
    api.rerender('57daf72b', render)
  })

}


export default __exports__